module.exports = __webpack_public_path__ + "img/cadena galvanizada.600551ab.jpg";